import React from "react"
import News from "../../blocks/news"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "saveljevs_latvia_u21" }) {
    ...NewsInfo
    innerImages {
      callSheet {
        childImageSharp {
          fluid(maxWidth: 1680) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
}`

export default class NewsText extends News {
  renderNews() {
    const { callSheet } = this.props.data.news.innerImages
    return (
      <div className="row">
        <div className="col-xl-12">
          <p>Полузащитник «Вероны» <Link to={ `/players/saveljevs` }>Алексейс Савельевс</Link> вызван в сборную Латвии U-21 для участия в двух отборочных матчах чемпионата Европы U-21 против сборной Польши (06.09.2019) и сборной Сербии (10.09.2019).</p>

          <Img fluid={ callSheet.childImageSharp.fluid } alt="Вызов Савельевса в сборную Латвии U-21" width="100%" />

        </div>
      </div>
    )
  }
}